const visitServices = {

  install (Vue, options) {
    Vue.prototype.VisitServices = {
      1: 'Face',
      2: 'Neck',
      3: 'Bikkini',
      4: 'Under arms',
      5: 'Full arms',
      6: 'Half arm lower',
      7: 'Half arm uppper',
      8: 'Full leg',
      9: 'Half leg lower',
      10: 'Half leg upper',
      11: 'Back',
      12: 'Half back',
      13: 'Stomach',
      
      DATA: [
        { id: 1, name: 'Face' },
        { id: 2, name: 'Neck' },
        { id: 3, name: 'Bikkini' },
        { id: 4, name: 'Under arms' },
        { id: 5, name: 'Full arms' },
        { id: 6, name: 'Half arm lower' },
        { id: 7, name: 'Half arm upper' },
        { id: 8, name: 'Full leg' },
        { id: 9, name: 'Half leg lower' },
        { id: 10, name: 'Half leg upper' },
        { id: 11, name: 'Back' },
        { id: 12, name: 'Half back' },
        { id: 13, name: 'Stomach' }
      ]
    }
  }
}

export default visitServices



// WEBPACK FOOTER //
// ./src/constants/visitServices.js